import { render, staticRenderFns } from "./FoalRegistration.vue?vue&type=template&id=181efc8c&"
import script from "./FoalRegistration.vue?vue&type=script&lang=js&"
export * from "./FoalRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports